<div class="promotion-materials">
    <p-toast position="top-right"></p-toast>

    <p-dialog [visible]="saving"
              appendTo="body"
              [modal]="true"
              [closable]="false"
              [showHeader]="false"
              [closeOnEscape]="false"
              [dismissableMask]="false"
              [draggable]="false"
              [resizable]="false"
              [style]="{ width: '22rem' }">
        <div class="promotion-materials__saving">
            <p-progressSpinner [style]="{width: '48px', height: '48px'}"
                               strokeWidth="4"
                               fill="transparent"
                               animationDuration=".5s"></p-progressSpinner>
            <p>Saving promotion material…</p>
        </div>
    </p-dialog>

    <div class="card">
        <div class="promotion-materials__header">
            <div>
                <h2>Promotion Materials</h2>
                <p>Manage customer-app carousel, Story Slideshow, and News &amp; Updates artwork.</p>
            </div>
            <button pButton type="button" label="Create material" icon="pi pi-plus"
                    (click)="create()"></button>
        </div>

        <div class="promotion-materials__filters">
            <span class="p-input-icon-left">
                <i class="pi pi-search"></i>
                <input pInputText type="text" placeholder="Internal name or promo"
                       [(ngModel)]="filter.SearchName" (keyup.enter)="applyFilters()">
            </span>
            <p-dropdown [options]="placements" optionLabel="label" optionValue="value"
                        placeholder="All placements" [showClear]="true"
                        [(ngModel)]="filter.Placement"></p-dropdown>
            <p-dropdown [options]="behaviors" optionLabel="label" optionValue="value"
                        placeholder="All behaviors" [showClear]="true"
                        [(ngModel)]="filter.Behavior"></p-dropdown>
            <p-dropdown [options]="activityOptions" optionLabel="label" optionValue="value"
                        placeholder="All statuses"
                        [(ngModel)]="filter.IsActive"></p-dropdown>
            <button pButton type="button" label="Apply" class="p-button-outlined"
                    (click)="applyFilters()"></button>
            <button pButton type="button" label="Clear"
                    class="p-button-text" (click)="clearFilters()"></button>
        </div>

        <p-table [value]="materials" [lazy]="true" (onLazyLoad)="load($event)"
                 [loading]="loading" [paginator]="true" [rows]="rows"
                 [first]="first" [totalRecords]="totalRecords"
                 [rowsPerPageOptions]="[25, 50, 100]" dataKey="Id"
                 responsiveLayout="scroll" styleClass="p-datatable-gridlines">
            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn="InternalName">Internal name <p-sortIcon field="InternalName"></p-sortIcon></th>
                    <th>Title</th>
                    <th pSortableColumn="Placement">Placement <p-sortIcon field="Placement"></p-sortIcon></th>
                    <th pSortableColumn="Behavior">Behavior <p-sortIcon field="Behavior"></p-sortIcon></th>
                    <th>Banner</th>
                    <th>Modal</th>
                    <th>Location</th>
                    <th>Mapped promo</th>
                    <th>Promo status</th>
                    <th pSortableColumn="DisplayOrder">Order <p-sortIcon field="DisplayOrder"></p-sortIcon></th>
                    <th pSortableColumn="IsActive">Published <p-sortIcon field="IsActive"></p-sortIcon></th>
                    <th>Actions</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-material>
                <tr>
                    <td>{{material.InternalName}}</td>
                    <td>{{displayTitle(material)}}</td>
                    <td>{{placementName(material.Placement)}}</td>
                    <td>{{isStorySlideMaterial(material) ? '—' : behaviorName(material.Behavior)}}</td>
                    <td><img class="promotion-materials__thumb" [src]="material.BannerImageUrl" alt="Banner"></td>
                    <td>
                        <img *ngIf="material.ModalImageUrl; else noModal"
                             class="promotion-materials__thumb" [src]="material.ModalImageUrl" alt="Modal">
                        <ng-template #noModal>—</ng-template>
                    </td>
                    <td class="promotion-materials__locations">{{locationNames(material)}}</td>
                    <td>
                        <ng-container *ngIf="material.XpressPromoId; else noPromo">
                            {{material.PromoCode}} — {{material.PromoName}}
                        </ng-container>
                        <ng-template #noPromo>—</ng-template>
                    </td>
                    <td>
                        <span *ngIf="material.PromoLifecycleStatus"
                              class="promotion-materials__status"
                              [class.promotion-materials__status--warning]="isUnavailablePromoStatus(material.PromoLifecycleStatus)">
                            {{material.PromoLifecycleStatus}}
                        </span>
                        <span *ngIf="!material.PromoLifecycleStatus">—</span>
                    </td>
                    <td>{{material.DisplayOrder}}</td>
                    <td>{{material.IsActive ? 'Yes' : 'No'}}</td>
                    <td class="promotion-materials__actions">
                        <button pButton type="button" icon="pi pi-pencil"
                                class="p-button-text" aria-label="Edit"
                                (click)="edit(material)"></button>
                        <button pButton type="button" icon="pi pi-trash"
                                class="p-button-text p-button-danger" aria-label="Delete"
                                (click)="delete(material)"></button>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr><td colspan="12">No promotion materials found.</td></tr>
            </ng-template>
        </p-table>
    </div>

    <p-sidebar [(visible)]="editorVisible" position="right"
               [style]="{width: '42rem'}" [modal]="true"
               [dismissible]="!saving" [closeOnEscape]="!saving" [showCloseIcon]="!saving">
        <ng-template pTemplate="header">
            <h3>{{model.Id ? 'Edit' : 'Create'}} promotion material</h3>
        </ng-template>

        <div class="promotion-materials__form">
            <div class="promotion-materials__field promotion-materials__field--full">
                <label for="material-name">Internal name <span class="promotion-materials__required">*</span></label>
                <input id="material-name" pInputText maxlength="200"
                       [(ngModel)]="model.InternalName">
                <small>For operator-portal identification only.</small>
            </div>

            <div class="promotion-materials__field">
                <label for="material-placement">Placement <span class="promotion-materials__required">*</span></label>
                <p-dropdown inputId="material-placement" [options]="placements"
                            optionLabel="label" optionValue="value"
                            [(ngModel)]="model.Placement"
                            (onChange)="placementChanged()"></p-dropdown>
                <small *ngIf="isStorySlide">Full-width slides on the customer home page. Tapping a slide opens its deeplink.</small>
            </div>

            <div class="promotion-materials__field">
                <label for="material-location">Location <span class="promotion-materials__required">*</span></label>
                <p-multiSelect inputId="material-location" [options]="zones"
                               optionLabel="Name" optionValue="Id"
                               placeholder="Select zones" [filter]="true" filterBy="Name"
                               [showToggleAll]="true" [maxSelectedLabels]="3"
                               selectedItemsLabel="{0} zones selected"
                               emptyMessage="No active zones in the Region Module"
                               [(ngModel)]="model.GeoZoneIds"></p-multiSelect>
                <small>Zones from the Region Module where this material is shown. Use the header checkbox to select all.</small>
            </div>

            <div class="promotion-materials__field promotion-materials__field--full"
                 *ngIf="model.Placement === placementEnum.NewsAndUpdates">
                <label for="material-title">Title <span class="promotion-materials__required">*</span></label>
                <input id="material-title" pInputText maxlength="200"
                       [(ngModel)]="model.Title">
                <small>Shown on the customer modal after tapping the banner.</small>
            </div>

            <div class="promotion-materials__field promotion-materials__field--full"
                 *ngIf="model.Placement === placementEnum.NewsAndUpdates">
                <label>Description <span class="promotion-materials__required">*</span></label>
                <p-editor [(ngModel)]="model.HtmlViewDescription" [style]="{'height':'240px'}"></p-editor>
                <small>HTML body shown under the modal image.</small>
            </div>

            <div class="promotion-materials__field promotion-materials__field--full"
                 *ngIf="model.Placement === placementEnum.Carousel">
                <label for="material-promo">Mapped promo <span class="promotion-materials__optional">Optional</span></label>
                <p-dropdown inputId="material-promo" [options]="promos"
                            optionLabel="PromotionMaterialLabel" optionValue="Id"
                            placeholder="Select a promo" [filter]="true" [showClear]="true"
                            filterBy="PromotionMaterialLabel"
                            [(ngModel)]="model.XpressPromoId"
                            (onChange)="promoChanged()"></p-dropdown>
                <small>Title, body, code, mechanics, dates, and eligibility come from this promo.</small>
            </div>

            <div class="promotion-materials__warning promotion-materials__field--full"
                 *ngIf="model.Placement === placementEnum.Carousel &&
                        isUnavailablePromoStatus(model.PromoLifecycleStatus)">
                The mapped promo is {{model.PromoLifecycleStatus | lowercase}}.
                Remap or unpublish this material. Customer expiry behavior is still awaiting product confirmation.
            </div>

            <!-- Story Slideshow fields -->
            <div class="promotion-materials__field promotion-materials__field--full" *ngIf="isStorySlide">
                <label for="material-header-text">Header text <span class="promotion-materials__optional">Optional</span></label>
                <input id="material-header-text" pInputText
                       [maxlength]="storySlideHeaderTextMaxLength"
                       placeholder="e.g. Arrive in comfort"
                       [(ngModel)]="model.HeaderText">
                <small>Large text overlaid on the slide.
                    <span class="promotion-materials__counter"
                          [class.promotion-materials__counter--limit]="headerTextRemaining === 0">
                        {{headerTextRemaining}} characters remaining
                    </span>
                </small>
            </div>

            <div class="promotion-materials__field promotion-materials__field--full" *ngIf="isStorySlide">
                <label for="material-cta-text">CTA text <span class="promotion-materials__optional">Optional</span></label>
                <input id="material-cta-text" pInputText
                       [maxlength]="storySlideCtaTextMaxLength"
                       placeholder="e.g. Request now"
                       [(ngModel)]="model.CtaText">
                <small>Call-to-action text under the header.
                    <span class="promotion-materials__counter"
                          [class.promotion-materials__counter--limit]="ctaTextRemaining === 0">
                        {{ctaTextRemaining}} characters remaining
                    </span>
                </small>
            </div>

            <div class="promotion-materials__field promotion-materials__field--full" *ngIf="isStorySlide">
                <label for="material-deeplink">Deeplink URL <span class="promotion-materials__optional">Optional</span></label>
                <input id="material-deeplink" pInputText maxlength="1000"
                       placeholder="xpress://book-a-ride"
                       [class.ng-invalid]="!!deeplinkError" [class.ng-dirty]="!!deeplinkError"
                       [(ngModel)]="model.DeeplinkUrl"
                       (ngModelChange)="deeplinkChanged()"
                       (blur)="deeplinkChanged()">
                <small *ngIf="!deeplinkError">Opened in the Xpress User App when the slide is tapped.</small>
                <small *ngIf="deeplinkError" class="promotion-materials__inline-error">{{deeplinkError}}</small>
            </div>

            <div class="promotion-materials__field">
                <label for="material-order">Display order <span class="promotion-materials__required">*</span></label>
                <p-inputNumber inputId="material-order" [min]="0"
                               [(ngModel)]="model.DisplayOrder"></p-inputNumber>
                <small *ngIf="isStorySlide">Must be unique among published slides that share a location.</small>
            </div>

            <div class="promotion-materials__field promotion-materials__switch">
                <label for="material-active">Published</label>
                <p-inputSwitch inputId="material-active"
                               [(ngModel)]="model.IsActive"></p-inputSwitch>
                <small *ngIf="isStorySlide">At most 10 published slides per location.</small>
            </div>

            <!-- Story Slideshow: single image -->
            <div class="promotion-materials__image-field" *ngIf="isStorySlide">
                <label for="story-image">Image <span class="promotion-materials__required">*</span></label>
                <input id="story-image" #storyImageInput type="file" accept=".jpg,.jpeg,.png,.webp,image/*"
                       (change)="storyImageSelected($event)">
                <small>{{storySlideImageHelp}}</small>

                <div *ngIf="bannerPreview" class="promotion-materials__slide-preview">
                    <img [src]="bannerPreview" alt="Slide preview">
                    <div class="promotion-materials__slide-preview-overlay">
                        <span class="promotion-materials__slide-preview-headline">{{model.HeaderText || 'Header text'}}</span>
                        <span class="promotion-materials__slide-preview-action">{{model.CtaText || 'CTA text'}} &rarr;</span>
                    </div>
                </div>
            </div>

            <!-- Carousel / News & Updates: banner + modal images -->
            <div class="promotion-materials__image-field" *ngIf="!isStorySlide">
                <label for="banner-image">Banner image <span class="promotion-materials__required">*</span></label>
                <input id="banner-image" #bannerImageInput type="file" accept=".jpg,.jpeg,.png,.webp,image/*"
                       (change)="imageSelected($event, 'banner')">
                <small>Horizontal or vertical artwork shown in the selected placement. Maximum 5 MB.</small>
                <img *ngIf="bannerPreview" [src]="bannerPreview" alt="Banner preview">
            </div>

            <div class="promotion-materials__image-field" *ngIf="!isStorySlide">
                <label for="modal-image">Modal image
                    <span *ngIf="model.Placement === placementEnum.Carousel; else modalImageRequired"
                          class="promotion-materials__optional">Optional</span>
                    <ng-template #modalImageRequired><span class="promotion-materials__required">*</span></ng-template>
                </label>
                <input id="modal-image" #modalImageInput type="file" accept=".jpg,.jpeg,.png,.webp,image/*"
                       (change)="imageSelected($event, 'modal')">
                <small *ngIf="model.Placement === placementEnum.Carousel; else modalImageHelp">
                    Shown after the customer taps the banner. Remove it to leave the banner without a modal image. Maximum 5 MB.
                </small>
                <ng-template #modalImageHelp>
                    <small>Artwork shown after the customer taps the banner. Maximum 5 MB.</small>
                </ng-template>
                <img *ngIf="modalPreview" [src]="modalPreview" alt="Modal preview">
                <button *ngIf="model.Placement === placementEnum.Carousel && modalPreview"
                        pButton type="button" label="Remove modal image" icon="pi pi-times"
                        class="p-button-text p-button-sm p-button-danger"
                        [disabled]="saving" (click)="removeModalImage()"></button>
            </div>
        </div>

        <div class="promotion-materials__footer">
            <button pButton type="button" label="Cancel"
                    class="p-button-outlined" [disabled]="saving" (click)="editorVisible = false"></button>
            <button pButton type="button" label="Save" icon="pi pi-check"
                    [loading]="saving" (click)="save()"></button>
        </div>
    </p-sidebar>
</div>
